<template>
  <div class="wrapper">
    <div class="main visual-5 visual-7 visual-8">
      <Header backRoute="/appointments" />
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="vis7-inr1">
              <h1>You're good to go!</h1>
              <p class="qr">
                <img src="@/assets/img/checkmark.png" alt="" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  name: "GoodToGo",
  components: {
    FooterView,
    Header,
  },
  mounted() {
    setTimeout(() => {
      this.$router.push("/appointments");
    }, 10000); // 5000ms = 5 seconds
  },
};
</script>

<style scoped></style>
